import styled from "styled-components";

import {
  TooltipDesc,
  TooltipInfo,
  TooltipName,
  TooltipValues,
  ValuesIcon,
} from "components/base/Tooltip";
import { getDerivedStatData } from "libs/stats";
import { CharacterDerivedStats } from "types";

interface TooltipStatsProps {
  slug: keyof CharacterDerivedStats;
  value: number;
  baseValue: number;
  upgradeValue: number;
}

const TooltipTotalStat = styled.div`
  font-weight: 600;
  filter: brightness(120%) saturate(120%);
  margin-top: 2px;
`;

const TotalStatName = styled.span`
  text-transform: uppercase;
`;

const TooltipDerivedStat = ({
  slug,
  value,
  baseValue,
  upgradeValue,
}: TooltipStatsProps) => {
  const statInfo = getDerivedStatData(slug);

  return (
    <>
      <TooltipName>{statInfo.name}</TooltipName>
      <TooltipDesc>{statInfo.description}</TooltipDesc>
      <TooltipInfo>
        <TooltipValues color={statInfo.color}>
          {`Base Value: ${statInfo.formatter(baseValue)}`}
        </TooltipValues>
        <TooltipValues color={statInfo.color}>
          {`Upgrade Bonus: [${statInfo.addFormatter(upgradeValue)}]`}
        </TooltipValues>
        <TooltipTotalStat>
          <TooltipValues color={statInfo.color}>
            <ValuesIcon image={statInfo.image} color={statInfo.color} />
            <div>
              <TotalStatName>Total Value: </TotalStatName>
              {statInfo.formatter(value)}
            </div>
          </TooltipValues>
        </TooltipTotalStat>
      </TooltipInfo>
    </>
  );
};

export default TooltipDerivedStat;
